import {OnShowError} from "@baseTypes/base";
import {BASE_TRACK_API_URL} from "@constants/config";
import {apiRequestWithAuth} from "@helpers/query/apiRequestWithAuth";
import {
	IBodyAddPointTemplateSingleVoyage,
	IBodyUpdatePointTemplateSingleVoyage,
	IPointTemplatesSingleVoyage,
} from "@containers/singleVoyage/pointTemplates/types";

export const getPointTemplatesSingleVoyage = async (
	{
		accountId,
	}: {
		accountId: number
	},
	onError?: OnShowError
): Promise<IPointTemplatesSingleVoyage[]> => {
	const url = `${BASE_TRACK_API_URL}/v1/accounts/${accountId}/single-voyage/waypoint-templates`
	const res = await apiRequestWithAuth<IPointTemplatesSingleVoyage[]>({
		url,
		options: {
			method: "GET",
		},
		onError,
	});
	return res?.map((row) => {
		return {
			...row,
			trackableObjectIds: row?.trackableObjectIds || row?.trackableObjects.map((row) => {
				return row?.id
			})
			
		}
	})
}

export const getPointTemplatesByIdsSingleVoyage = async (
	{
		accountId,
		ids,
	}: {
		accountId: number
		ids: number[]
	},
	onError?: OnShowError
): Promise<IPointTemplatesSingleVoyage[]> => {
	const idsStr = ids?.map((id) => `waypointTemplateIds=${id}`).join('&')
	const url = `${BASE_TRACK_API_URL}/v1/accounts/${accountId}/single-voyage/waypoint-templates?${idsStr}`
	return apiRequestWithAuth({
		url,
		options: {
			method: "GET",
		},
		onError,
	});
}


export const getPointTemplateByIdSingleVoyage = async (
	{
		accountId,
		id,
	}: {
		accountId: number
		id: number
	},
	onError?: OnShowError
): Promise<IPointTemplatesSingleVoyage> => {
	const url = `${BASE_TRACK_API_URL}/v1/accounts/${accountId}/single-voyage/waypoint-templates/${id}`
	return apiRequestWithAuth({
		url,
		options: {
			method: "GET",
		},
		onError,
	});
}


export const addPointTemplateSingleVoyage = async ({
													   accountId,
													   ...body
												   }: IBodyAddPointTemplateSingleVoyage,): Promise<IPointTemplatesSingleVoyage> => {
	const url = `${BASE_TRACK_API_URL}/v1/accounts/${accountId}/single-voyage/waypoint-templates`
	
	return apiRequestWithAuth({
		url,
		options: {
			method: "POST",
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body)
		},
	});
}

export const updatePointTemplateSingleVoyage = async ({
														  accountId,
														  id,
														  ...body
													  }: IBodyUpdatePointTemplateSingleVoyage,): Promise<IPointTemplatesSingleVoyage> => {
	const url = `${BASE_TRACK_API_URL}/v1/accounts/${accountId}/single-voyage/waypoint-templates/${id}`
	return apiRequestWithAuth({
		url,
		options: {
			method: "PUT",
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body)
		},
	});
}


export const deletePointTemplateSingleVoyage = async ({id, accountId}: {
	id: number | string,
	accountId: number | string
}) => {
	const url = `${BASE_TRACK_API_URL}/v1/accounts/${accountId}/single-voyage/waypoint-templates/${id}`
	
	return apiRequestWithAuth({
		url,
		options: {
			method: "DELETE",
		},
	});
}

